import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-font-icon',
  templateUrl: './text-font.component.html'
})
export class TextFontComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
